import type { ReservationsReportComponentProps } from './ReservationsReportComponent';

export const ReservationsReportComponent = {
    MountAsync: async (target: HTMLElement, props: ReservationsReportComponentProps) => {
        const { mountReactComponentAsync } = await import('@/utils/mountReactComponentAsync');
        const { ReservationsReportComponent } = await import('./ReservationsReportComponent');
        return await mountReactComponentAsync(target, ReservationsReportComponent, props);
    }
};